module.exports = __webpack_public_path__ + "img/company-honor-RoHS-20240408.39abd823.jpg";